import React from 'react';

const PropertyDetails = () => {
    // --- Styles as JavaScript Objects (Equivalent of Inline CSS) ---
    const globalBodyStyle = {
        fontFamily: 'Arial, sans-serif',
        margin: '20px',
        color: '#333',
    };

    const headerStyle = {
        textAlign: 'center',
        backgroundColor: '#ffffffff',
        padding: '10px',

        fontWeight: 'bold',
    };

    const tableStyle = {
        width: '50%',
        margin: '20px auto',
        borderCollapse: 'collapse',
        border: '1px solid #000',
    };

    const specificationTableStyle = {
        width: '80%',
        margin: '20px auto',
        borderCollapse: 'collapse',
        border: '1px solid #000',
    };

    const thStyle = {
        backgroundColor: '#333',
        color: 'white',
        padding: '10px',
        border: '1px solid #000',
        textAlign: 'left',
    };

    const tdStyle = {
        padding: '10px',
        border: '1px solid #ccc',
    };

    const specHeaderColStyle = { // Style for the dark column headers in Specification table
        width: '20%',
        backgroundColor: '#333',
        color: 'white',
        fontWeight: 'bold',
        padding: '10px',
        border: '1px solid #000',
        textAlign: 'left',
    };
    
    const specContentColStyle = { // Style for the content column in Specification table
        width: '80%', 
        ...tdStyle 
    };

    return (
        <div style={globalBodyStyle}>
            {/* 1. Area Statement */}
            <h2 style={headerStyle}>Area Statement</h2>

            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thStyle}>Flat Number</th>
                        <th style={thStyle}>Total SQ.FT</th>
                        <th style={thStyle}>No. of BHK</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={tdStyle}>Flat A</td>
                        <td style={tdStyle}>1736 Sq.ft</td>
                        <td style={tdStyle}>3 BHK</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>Flat B</td>
                        <td style={tdStyle}>1458 SQ.FT</td>
                        <td style={tdStyle}>3 BHK</td>
                    </tr>
                </tbody>
            </table>

            {/* 2. Specification */}
            <h2 style={{ ...headerStyle, marginTop: '40px' }}>Specification</h2>

            <table style={specificationTableStyle}>
                <tbody>
                    <tr>
                        <td style={specHeaderColStyle}>STRUCTURE</td>
                        <td style={specContentColStyle}>RCC framed structure with columns, beams and masonry walls.</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>FLOORING</td>
                        <td style={specContentColStyle}>
                            80x80cms Premium quality vitrified floor tiles for Hall.<br />
                            Dining and 60x60cms for Bedrooms.<br />
                            Kitchen and Anti-skid tiles for other areas.
                        </td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>KITCHEN</td>
                        <td style={specContentColStyle}>Black granite top with edge polished with stainless steel sink and wall tiles up to 2 feet height above kitchen table</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>DOORS & SHUTTERS</td>
                        <td style={specContentColStyle}>Doors and shutters wood frames and paneled main door. And all doors with teak wood frames with factory made skin door with enamel paint. UPVC windows with plain glass and Mild steel grills.</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>PAINTING</td>
                        <td style={specContentColStyle}>Two coats of emulsion paint over primer with putty finish for all inner walls and for door frames, doors and grills with two coats of quality enamel paint.</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>BATH ROOM</td>
                        <td style={specContentColStyle}>Kohler or equivalent EWC for attached and IWC for common bathrooms with Jaguar or equivalent CP fittings and coloured ceramic anti-skid tiles flooring and Glazed tiles up to full height for toilet</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>ELECTRICAL</td>
                        <td style={specContentColStyle}>3 phase concealed copper wiring with ISI brand with branded modular switches. Inverter (UPS) provision and wiring for selected points. Electrical provisions for A/C in all bed rooms, geyser in toilets, washing machine, fridge, oven, grinder and TV point in hall and one bedroom. Also points for telephone in hall and provision for intercom in hall.</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>LIFT</td>
                        <td style={specContentColStyle}>Auto door 6 passenger lift.</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>GENERATOR</td>
                        <td style={specContentColStyle}>A standby generator for lift, pumps and common lights.</td>
                    </tr>
                    <tr>
                        <td style={specHeaderColStyle}>ALTERATION WORK</td>
                        <td style={specContentColStyle}>Any alteration work, material cost and labour charges will be borne by customer and no deductions will be made.</td>
                    </tr>
                </tbody>
            </table>

            {/* 3. Payment Schedule */}
            <h2 style={{ ...headerStyle, marginTop: '40px' }}>Payment Schedule</h2>

            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thStyle}>Details</th>
                        <th style={thStyle}>Payment</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={tdStyle}>On or before 30th day (From the date of booking)</td>
                        <td style={tdStyle}>20% (After deducting Advance)</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>At the time of Basement</td>
                        <td style={tdStyle}>15%</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>At the time of Registration</td>
                        <td style={tdStyle}>15%</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>At the time of Respective Floor roofs</td>
                        <td style={tdStyle}>15%</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>At the time of Respective Flat Brick Works</td>
                        <td style={tdStyle}>15%</td>
                    </tr>
                    <tr>
                        <td style={tdStyle}>At the time of Respective Flat Plastering</td>
                        <td style={tdStyle}>10%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PropertyDetails;